<template>
  <div>
    <lk-form slot='content' :model='goodsForm' :rules='validate' :label-width='134'
      label-position="right" ref="goodsForm">
      <div class="cardContainer">
        <lk-card title='基础商品信息'>
          <lk-row :gutter='16'>
            <lk-col span='7'>
              <lk-form-item label='商品名称:' prop='approvedDrugNames' ref="approvedDrugNames">
                  <lk-input @on-change='setMnemonicCode(goodsForm.approvedDrugNames)'
                    v-model.trim="goodsForm.approvedDrugNames" :maxlength='40'  clearable
                    placeholder="请输入" v-if="able"></lk-input>
                  <span v-else>{{goodsForm.approvedDrugNames}}</span>
              </lk-form-item>
            </lk-col>
            <lk-col span='7'>
              <lk-form-item label='生产企业:' prop='manufacturer'>
                <lk-select
                v-if="able"
                 clearable
                 placeholder='请选择'
                 :filterable="true"
                  v-model.trim="goodsForm.manufacturer">
                  <lk-option v-for="(item,index) in enterpriseList"
                    :value='item.name' :key="index">{{ item.name }}</lk-option>
                </lk-select>
                <span v-else>{{goodsForm.manufacturer}}</span>
              </lk-form-item>
            </lk-col>
            <lk-col span='7' :offset='1'>
              <lk-form-item label='是否进口:'>
                <lk-radio-group v-model.trim="goodsForm.isImport" v-if="able">
                  <lk-radio :label="1" :value="1" >是</lk-radio>
                  <lk-radio :label="2" :value="2" >否</lk-radio>
                </lk-radio-group>
                <span v-else>{{goodsForm.isImport ===1 ? '是': '否'}}</span>
              </lk-form-item>
            </lk-col>
          </lk-row>
          <lk-row :gutter='16'>
            <lk-col span='7' >
              <lk-form-item label='说明书:' prop='manualUrl'>
                <Uploader :able='able' v-model='goodsForm.manualUrl'></Uploader>
              </lk-form-item>
            </lk-col>
              <lk-col span='7' >
                  <lk-form-item label='商品图片:' prop='drugImageUrl'>
                    <Uploader :able='able' v-model.trim="goodsForm.drugImageUrl">
                    </Uploader>
                  </lk-form-item>
                </lk-col>
            <lk-col span='7' :offset='1'>
              <lk-form-item label='样本类型:' prop='sampleType'>
                <lk-cascader v-if="able" :data="sampleTypeList" v-model.trim="goodsForm.sampleType"></lk-cascader>
                <span v-else>{{this.sampleTypeObj[goodsForm.sampleType]}}</span>
              </lk-form-item>
            </lk-col>
          </lk-row>
        </lk-card>
      </div>
      <div class="cardContainer">
        <lk-card title='商品标签'>
          <lk-row :gutter='16'>
            <lk-col span='7'>
              <lk-form-item label='GSP管理分类:' class="storeSelect" >
                <lk-select v-if="able" v-model="goodsForm.gspIdList" filterable multiple>
                  <lk-option v-for="(option,index) in baseData.label.gspArr" :value='option.id'
                    :key="index">{{option.name}}</lk-option>
                </lk-select>
                <span v-else>{{goodsForm.gsps }}</span>
              </lk-form-item>
            </lk-col>
            <lk-col span='7' :offset='1'>
              <lk-form-item label='经营范围:' class="storeSelect" prop='bizIdList'>
                <lk-select v-if="able" v-model="goodsForm.bizIdList" filterable multiple>
                  <lk-option v-for="(option,index) in baseData.label.bizArr" :value='option.id'
                    :key="index">{{option.name}}</lk-option>
                </lk-select>
                <span v-else>{{goodsForm.bizs }}</span>
              </lk-form-item>
            </lk-col>
            <lk-col span='7' :offset='1'>
              <lk-form-item label='生产范围:' class="storeSelect">
                <lk-select v-if="able" v-model="goodsForm.prodIdList" filterable multiple>
                  <lk-option v-for="(option,index) in baseData.label.prodArr" :value='option.id'
                    :key="index">{{option.name}}</lk-option>
                </lk-select>
                 <span v-else>{{goodsForm.prods }}</span>
              </lk-form-item>
            </lk-col>
          </lk-row>
          <lk-row :gutter='16'>
            <lk-col span='7'>
              <lk-form-item label='其他:' class="storeSelect">
                <lk-select v-if="able" v-model="goodsForm.otherIdList" filterable multiple>
                  <lk-option v-for="(option,index) in baseData.label.otherArr" :value='option.id'
                    :key="index">{{option.name}}</lk-option>
                </lk-select>
                <span v-else>{{goodsForm.others }}</span>
              </lk-form-item>
            </lk-col>
          </lk-row>
        </lk-card>
      </div>
      <div class="cardContainer">
        <lk-card title='证件信息'>
          <lk-form :label-width='130' label-position="right" :model='goodsForm'
            ref="groupCheck" >
            <lk-row :gutter='16'>
              <lk-col class="backGroundCard" span='7'>
                <lk-row>
                  <lk-col span='24'>
                    <lk-form-item prop='prodLicenseUrl'>
                      <div class="label withPic">
                        <label>生产许可证:</label>
                      </div>
                      <Uploader :able='able' v-model.trim="goodsForm.prodLicenseUrl">
                      </Uploader>
                    </lk-form-item>
                  </lk-col>
                  <lk-col span='24'>
                    <lk-form-item label='证件号:'>
                      <lk-input
                        v-if="able"
                        :maxlength='20'
                        v-model.trim="goodsForm.prodLicenseCode"
                      ></lk-input>
                      <span v-else>{{goodsForm.prodLicenseCode}}</span>
                    </lk-form-item>
                  </lk-col>
                  <lk-col span='24'>
                    <lk-form-item label='有效期:' >
                      <expire-picker :able='able' :type='1' v-model.trim="goodsForm.periodProdLicense"/>
                    </lk-form-item>
                  </lk-col>
                </lk-row>
              </lk-col>
            </lk-row>
          </lk-form>
        </lk-card>
      </div>
    </lk-form>
  </div>
</template>

<script>
import Uploader from '../../Uploader.vue';
import ExpirePicker from '../../expireInfo/expirePicker.vue';

export default {
  name: 'Cso',
  components: {
    Uploader,
    ExpirePicker,
  },
  props: {
    info: {
      type: Object,
    },
    able: {
      type: Boolean,
    },
    isImport: {
      type: Boolean,
    },
    baseData: {
      type: Object,
    },
  },
  model: {
    prop: 'info',
    event: 'change',
  },
  computed: { },
  watch: {
    info: {
      handler() {
        this.indicationDicArray = (this.info && this.info.indicationDicArray) ? this.info.indicationDicArray.split(',') : [];
        this.goodsForm = this.info;
      },
      deep: true,
    },
    goodsForm: {
      handler() {
        this.firstCheck();
        this.$emit('change', this.goodsForm);
      },
      deep: true,
    },
    indicationDicArray: {
      handler(val) {
        if (val && val.length) {
          this.goodsForm.indicationDicId = val[val.length - 1];
          this.goodsForm.indicationDicArray = val.join(',');
        } else {
          this.goodsForm.indicationDicId = null;
          this.goodsForm.indicationDicArray = '';
        }
      },
      deep: true,
    },
  },

  data() {
    return {
      disableExistsTest: false,
      isImportArr: ['', '是', '否'],
      enterpriseList: [
        {
          id: 1,
          name: '承葛生物',
        },
        {
          id: 2,
          name: '海普洛斯',
        },
        {
          id: 3,
          name: '颐护心理',
        },
        {
          id: 4,
          name: '布平医学',
        },
        {
          id: 5,
          name: '莲和医学',
        },
        {
          id: 6,
          name: '零氪科技',
        },
        {
          id: 7,
          name: '猎源检测',
        },
        {
          id: 8,
          name: '元码基因',
        },
        {
          id: 9,
          name: '泛生子基因',
        },
        {
          id: 10,
          name: '安诺优达',
        },
        {
          id: 11,
          name: '索真基因',
        },
      ],
      validate: {
        approvedDrugNames: [
          { required: true, message: '请输入商品名称', trigger: 'blur' },
          { validator: this.existsTest, trigger: 'blur' },
        ],
        manufacturer: [
          { required: true, message: '请输入生产企业', trigger: 'blur' },
          { validator: this.existsTest, trigger: 'blur' },
        ],
        sampleType: [
          {
            required: true, message: '请输入样本类型', trigger: 'blur', type: 'array',
          },
          { validator: this.existsTest, trigger: 'blur' },
        ],
      },
      sampleTypeList: [
        {
          value: 88888,
          label: '单样本',
          children: [
            {
              value: 1,
              label: '组织',
            },
            {
              value: 2,
              label: '血液',
            },
            {
              value: 12,
              label: '组织+血液对照',
            },
          ],
        },
        {
          value: 99999,
          label: '双样本',
          children: [
            {
              value: 11,
              label: '组织+组织',
            },
            {
              value: 22,
              label: '血液+血液',
            },
            {
              value: 21,
              label: '组织+血液',
            },
          ],
        },
        {
          value: 3,
          label: '其他',
        },
      ],
      sampleTypeObj: {
        1: '单样本/组织',
        2: '单样本/血液',
        3: '其他',
        11: '双样本/组织+组织',
        12: '单样本/组织+血液对照',
        21: '双样本/组织+血液',
        22: '双样本/血液+血液',
      },
      goodsForm: {
        isImport: 2,
        storageConditions: 1,
        minTemp: null,
        maxTemp: null,
      },
      firstFill: {},
      indicationDicArray: [],

    };
  },
  methods: {
    firstCheck() {
      this.goodsForm.approvedDrugNames && (this.$refs.approvedDrugNames.validateState = '');// 强制清除验证状态
      if (!(this.goodsForm.approvedDrugNames || this.goodsForm.manufacturer || this.goodsForm.sampleType)) {
        this.disableExistsTest = true;
        let firstFill = null;
        ['approvedDrugNames',
          'manufacturer',
          'sampleType',
        ].forEach((item) => {
          this.$refs.goodsForm.validateField(item, (msg) => {
            if (msg) {
              firstFill = msg;
            }
          });
        });
        if (firstFill) {
          this.$Message.error('请先填写商品名称 和生产企业');
        }
        this.disableExistsTest = false;
      }
    },
    setMnemonicCode(name) {
      this.$emit('setMnemonicCode', name);
    },
    handleSelect(data) {
      this.$emit('import', data);
    },
    validateForm(isSubmit) {
      this.$emit('change', this.goodsForm);
      return new Promise((resolve) => {
        let validate = true;
        this.disableExistsTest = true;
        if (isSubmit) {
          this.$refs.goodsForm.validate((goodsFormValid) => {
            resolve(goodsFormValid);
            this.disableExistsTest = false;
          });
        } else {
          [
            'approvedDrugNames',
            'manufacturer',
            'sampleType',
          ].forEach((item) => {
            this.$refs.goodsForm.validateField(item, (msg) => {
              if (msg) {
                validate = false;
              }
            });
          });
          this.$nextTick(() => {
            this.disableExistsTest = false;
            resolve(validate);
          });
        }
      });
    },
    existsTest(rule, value, callback) {
      if (this.goodsForm.approvedDrugNames && this.goodsForm.manufacturer && this.goodsForm.sampleType && !this.disableExistsTest) {
        this.$emit('change', this.goodsForm);
        const temp = {
          approvedDrugNames: this.goodsForm.approvedDrugNames,
          manufacturer: this.goodsForm.manufacturer,
          sampleType: this.goodsForm.sampleType,
        };
        this.$emit('handleExist', temp);
      }
      callback();
    },
  },

  created() {
    this.validate = {
      approvedDrugNames: [
        { required: true, message: '请输入通用名', trigger: 'blur' },
        { validator: this.existsTest, trigger: 'blur' },
      ],
      manufacturer: [
        { required: true, message: '请输入生产企业', trigger: 'change' },
        { validator: this.existsTest, trigger: 'blur' },
      ],
      sampleType: [
        {
          required: true, message: '请输入样本类型', trigger: 'change', type: 'array',
        },
        { validator: this.existsTest, trigger: 'blur' },
      ],
      temp: [{ required: true, validator: this.testTemp, trigger: 'blur' }],
    };
    if (!this.able) {
      this.validate = {};
    }
  },
  mounted() {
    if (this.$route.params.id) {
      if (this.able) {
        const sampleType = [];
        this.sampleTypeList.forEach((item) => {
          if (item.value === this.info.sampleType) sampleType.push(this.info.sampleType);
          item.children && item.children.forEach((child) => {
            if (child.value === this.info.sampleType) {
              sampleType.push(item.value);
              sampleType.push(this.info.sampleType);
            }
          });
        });
        this.info.sampleType = sampleType;
      }
      this.goodsForm = this.info;
      this.indicationDicArray = (this.info && this.info.indicationDicArray) ? this.info.indicationDicArray.split(',') : [];
    }
  },
};
</script>

<style scoped>
  .cardContainer{
    margin-bottom: 16px
  }
  .storageConditions{
    display: flex;
    align-items: center;
    justify-content: space-between

  }
  .fakeFormItem{
    margin-left: -36px
  }
  .other{
    width: 40%;
  }
</style>
